<template>
    <div class="network-credential" :class="{loading: loading}">
        <form @submit.prevent="saveNetworkCredential" accept-charset="UTF-8" novalidate="novalidate">
            <fieldset>
                <div class="row">
                    <div class="form-group has-feedback col-sm-6"
                         :class="{'has-error': errors.has('NetworkCredential[project_id]')}">
                        <label for="network-credential-project-id">Project</label>
                        <select id="network-credential-project-id"
                                v-validate="'required'"
                                v-model="networkCredential.project_id"
                                name="NetworkCredential[project_id]"
                                class="form-control"
                                aria-required="true">
                            <option value="">-</option>
                            <option v-for="project in projects" :value="project.id">
                                {{project.name}}
                            </option>
                        </select>

                        <span v-show="errors.has('NetworkCredential[project_id]')" class="help-block">
                            {{ errors.first('NetworkCredential[project_id]') }}
                        </span>
                    </div>

                    <div class="form-group has-feedback col-sm-6"
                         :class="{'has-error': errors.has('NetworkCredential[username]')}">
                        <label for="network-credential-username">Username</label>

                        <input id="network-credential-username"
                               v-validate="'required'"
                               v-model="networkCredential.username"
                               name="NetworkCredential[username]"
                               type="text"
                               class="form-control"
                               aria-required="true">

                        <span v-show="errors.has('NetworkCredential[username]')" class="help-block">
                            {{ errors.first('NetworkCredential[username]') }}
                        </span>
                    </div>
                </div>

                <div class="row">
                    <div class="form-group has-feedback col-sm-6"
                         :class="{'has-error': errors.has('NetworkCredential[ssid_id]')}">
                        <label for="network-credential-ssid-id">SSID</label>

                        <select id="network-credential-ssid-id"
                                v-validate="'required'"
                                v-model="networkCredential.ssid_id"
                                name="NetworkCredential[ssid_id]"
                                class="form-control"
                                aria-required="true">
                            <option value="">-</option>
                            <option v-for="ssid in ssids" :value="ssid.id">
                                {{ssid.name}}
                            </option>
                        </select>

                        <span v-show="errors.has('NetworkCredential[ssid_id]')" class="help-block">
                            {{ errors.first('NetworkCredential[ssid_id]') }}
                        </span>
                    </div>

                    <div class="col-sm-6 form-group"
                         :class="{'has-error': errors.has('NetworkCredential[password]')}">
                        <label for="network-credential-password">Password</label>

                        <input id="network-credential-password"
                               name="NetworkCredential[password]"
                               type="text"
                               v-model="networkCredential.password"
                               v-validate="'required'"
                               class="form-control">

                        <span v-show="errors.has('NetworkCredential[password]')" class="help-block">
                            {{ errors.first('NetworkCredential[password]') }}
                        </span>
                    </div>
                </div>

                <hr>

                <div class="row">
                    <div class="col-sm-6 col-md-4">
                        <button type="submit" class="btn btn-success btn-block btn-lg" :disabled="loading">
                            Save
                        </button>
                    </div>
                </div>
            </fieldset>
        </form>
    </div>
</template>

<script>
    export default {
        props: {},

        created(){
            this.init();
        },

        data(){
            var result = {
                loading: true,

                networkCredential: {
                    project_id: null,
                    username: null,
                    password: null,
                    ssid_id: null,
                },

                projects: [],
                ssids: [],
            };

            return _.merge( result, this.defaults );
        },
        computed: {},
        watch: {
            'networkCredential.project_id'(){
                this.loadSSIDs();
            }
        },
        methods: {
            init(){
                this.loading = true;

                return this.loadProjects()
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            loadProjects(){
                var url = '/api/projects';

                return axios.get( url )
                    .then( ( response ) => {
                        var projects = response.data.Projects;

                        this.$set( this, 'projects', projects );
                    } );
            },

            loadSSIDs(){
                this.loading = true;

                if( !this.networkCredential.project_id ){
                    this.$set( this, 'ssids', [] );

                    return Promise.resolve( {} );
                }

                return axios.get( '/api/ssids?project_id=' + this.networkCredential.project_id )
                    .then( ( response ) => {
                        this.$set( this, 'ssids', response.data.SSIDs );
                    } )
                    .finally( () => {
                        this.loading = false;
                    } )
                    .catch( this.$root.handleErrors );
            },

            // Network Credentials
            saveNetworkCredential(){
                return this.$validator.validateAll()
                    .then( ( valid ) => {
                        if( valid ){
                            this.loading = true;

                            var form = document.createElement( 'form' );
                            form.setAttribute( 'method', 'POST' );
                            form.setAttribute( 'action', '/networkCredentials' );

                            var hiddenField = document.createElement( 'input' );
                            hiddenField.setAttribute( 'type', 'hidden' );
                            hiddenField.setAttribute( 'name', '_method' );
                            hiddenField.setAttribute( 'value', 'POST' );
                            form.appendChild( hiddenField );

                            var tokenField = document.createElement( 'input' );
                            tokenField.setAttribute( 'type', 'hidden' );
                            tokenField.setAttribute( 'name', '_token' );
                            tokenField.setAttribute( 'value', $( 'meta[name="csrf-token"]' ).attr( 'content' ) );
                            form.appendChild( tokenField );

                            var passwordField = document.createElement( 'input' );
                            passwordField.setAttribute( 'type', 'hidden' );
                            passwordField.setAttribute( 'name', 'NetworkCredential[password]' );
                            passwordField.setAttribute( 'value', this.networkCredential.password );
                            form.appendChild( passwordField );

                            var usernameField = document.createElement( 'input' );
                            usernameField.setAttribute( 'type', 'hidden' );
                            usernameField.setAttribute( 'name', 'NetworkCredential[username]' );
                            usernameField.setAttribute( 'value', this.networkCredential.username );
                            form.appendChild( usernameField );

                            var ssidIdField = document.createElement( 'input' );
                            ssidIdField.setAttribute( 'type', 'hidden' );
                            ssidIdField.setAttribute( 'name', 'NetworkCredential[ssid_id]' );
                            ssidIdField.setAttribute( 'value', this.networkCredential.ssid_id );
                            form.appendChild( ssidIdField );

                            var projectIdField = document.createElement( 'input' );
                            projectIdField.setAttribute( 'type', 'hidden' );
                            projectIdField.setAttribute( 'name', 'NetworkCredential[project_id]' );
                            projectIdField.setAttribute( 'value', this.networkCredential.project_id );
                            form.appendChild( projectIdField );

                            document.body.appendChild( form );

                            form.submit();
                        }
                    } );
            },

            openModal(){
                this.$modal.show( this.modalId );
            }
        }
    }
</script>
